export { default as MruCache } from './MruCache';
